import { clearAuthTokens } from './token-storage'

type ForceLogoutHandler = () => void

let handler: ForceLogoutHandler | null = null

/**
 * Lets the HTTP layers, which live outside React, end the session through the
 * SessionProvider. Returns the unregister function.
 */
export const registerForceLogoutHandler = (
  nextHandler: ForceLogoutHandler,
): (() => void) => {
  handler = nextHandler

  return () => {
    if (handler === nextHandler) {
      handler = null
    }
  }
}

export const forceLogout = () => {
  clearAuthTokens()

  // Going through the context keeps the route guards in charge of the redirect;
  // the hard redirect is only for when no provider is mounted.
  if (handler) {
    handler()
    return
  }

  window.location.href = '/login'
}
